import React, { Component } from "react";

import { Card, Button, Table, Modal, BackTop, message } from "antd";

import { connect } from "react-redux";
import {
  req_page_ams_alumni_deptofficer,
  req_edit_ams_alumni_deptofficer,
} from "../../api";

import {
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";

import SecretaryEditModal from "./secretary-edit-modal";

class AlumniAssignTasks extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    userLevel: "NORMAL",
    items: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",
    loading: false,
    domnloadFile: "",
    isEditInfoModal: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_page_items(1);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize.bind(this));
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const { searchField, searchValue, columnSort, orderBy, filterStatus } =
      this.state;
    const { token, userCode, role } = this.props.user;

    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_page_ams_alumni_deptofficer(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token
    );
    this.setState({ loading: false });

    //console.log(result)
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
  };

  api_edit_item = async (item) => {
    const { token } = this.props.user;
    item.condition = "BASE";
    this.setState({ loading: true });
    const result = await req_edit_ams_alumni_deptofficer(item, token);
    this.setState({ loading: false });
    //console.log(result);
    if (result.status === "success") {
      message.success(result.message);
    } else {
      message.error(result.message);
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "學院",
        dataIndex: "CollegeName",
        width: 40,
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "科系",
        dataIndex: "DBDeptName",
        width: 50,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "調查員",
        width: 30,
        render: (record) => {
          const { DeptOfficerName } = record;
          return (
            <div className="text-left">
              <Button onClick={() => this.handle_show_ui_modal("edit", record)}>
                <i className="fa fa-user" style={{ marginRight: "4px" }}></i>{" "}
                <span>{DeptOfficerName}</span>
              </Button>
            </div>
          );
        },
      },
    ];
  };

  style_switch_color_tag(column, param) {
    switch (column) {
      case "NowStatusSecondary":
        switch (param) {
          case "尚待確認":
            return "red";
          case "就業":
          case "服役":
          case "升學":
          case "留學":
            return "green";
          case "其他":
            return "purple";
          default:
            return "default";
        }
      default:
        break;
    }
  }
  // 操作互動處理 //////////////////////////////////////////////

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_download = () => {
    this.api_downloadfile_items();
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "view":
        this.setState({ isShowInfoModal: true, item });
        break;
      case "edit":
        this.setState({ isEditInfoModal: true, item });
        break;
      default:
    }
  };

  handleSubmit() {
    const row = this.state.item;

    //console.log(row);
    this.api_edit_item(row);
  }

  /////////////////////////////////////////////////////////////

  render() {
    const { isEditInfoModal, loading, item, items, pagination } = this.state;
    return (
      <>
        <Card>
          <Table
            bordered
            scroll={{ y: 480 }}
            loading={loading}
            rowKey="Uid"
            dataSource={items}
            onChange={this.handle_table_change}
            pagination={{
              ...pagination,
              responsive: true,
              showQuickJumper: true,
              showSizeChanger: true,
              pageSizeOptions: [5, 10, 20, 50, 100],
              // onChange: this.api_page_applycase,
              onShowSizeChange: this.handle_page_size_change,
            }}
            columns={this.columns}
          />

          <Modal
            destroyOnClose={true}
            title="修改調查員"
            visible={isEditInfoModal}
            onOk={() => {
              this.setState({ isEditInfoModal: false });
              this.handleSubmit();
            }}
            onCancel={() => {
              this.setState({ isEditInfoModal: false });
            }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <SecretaryEditModal depart={item} />
          </Modal>

          <BackTop visibilityHeight="80" />
        </Card>
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(AlumniAssignTasks);
